import React from 'react';

import { DateRange } from '@components/DateRangePicker/DateRangePickerModal';
import { ContactType } from '@components/Invite/Contact';
import { Box } from '@components/Restyle';
import { PopupTaskButtonWebV3 } from '@components/Web/PopupTaskButtonV3.web';
import { PopupTaskSortButtonV3 } from '@components/Web/PopupTaskSortButtonV3.web';
import { PublicCalendarLinkButtonV3 } from '@components/Web/PublicCalendarLinkButtonV3.web';
import { Project, TaskPriority, TaskSortOption } from '@graphql/generated';

export const TasksFilterBar: React.FC<{
  selectedProjects?: Project[];
  setSelectedProjects?: (x: Project[]) => void;
  initialAssignees?: ContactType[];
  selectedAssignees: ContactType[];
  setSelectedAssignees: (x: ContactType[]) => void;
  selectedDueDateRange: DateRange;
  setSelectedDueDateRange: (x: DateRange) => void;
  selectedPriorities: TaskPriority[];
  setSelectedPriorities: (x: TaskPriority[], marginTop?: string) => void;

  selectedDueDateStrList: string[];
  setSelectedDueDateStrList: (x: string[]) => void;
  selectedSortList: TaskSortOption[];
  setSelectedSortList: (x: TaskSortOption[]) => void;
}> = ({
  selectedProjects,
  setSelectedProjects,
  selectedPriorities,
  setSelectedPriorities,
  selectedAssignees,
  setSelectedAssignees,
  initialAssignees,
  selectedDueDateRange,
  setSelectedDueDateRange,
  selectedDueDateStrList,
  setSelectedDueDateStrList,
  setSelectedSortList,
  selectedSortList,
}) => {
  const popupMarginTop = 4;
  return (
    <>
      <Box
        accessibilityLabel='Task Filter Bar'
        ml='m'
        mr='s'
        mt='xs'
        mb='xxs'
        flexDirection='row'
        justifyContent='flex-start'>
        {selectedProjects && (
          <>
            <PopupTaskButtonWebV3
              iconName='AlignCenterDesc'
              badgeNumber='1'
              title='Filter'
              boxProps={{
                position: 'right',
                offset: [0, popupMarginTop],
              }}
              selectedProjects={selectedProjects}
              onSelectProjects={setSelectedProjects}
              onSelectAssignee={setSelectedAssignees}
              selectedAssignee={selectedAssignees}
              initialAssignees={initialAssignees}
              onSelectPriority={setSelectedPriorities}
              selectedPriorities={selectedPriorities}
              onSelectDuedate={setSelectedDueDateRange}
              selectedDuedate={selectedDueDateRange}
              onSelectedDueDateStrList={setSelectedDueDateStrList}
              selectedDueDateStrList={selectedDueDateStrList}
            />
            <Box mr='xs'></Box>

            <PopupTaskSortButtonV3
              boxProps={{
                position: 'right',
                offset: [0, popupMarginTop],
              }}
              selectedSorts={selectedSortList}
              onSelectedSorts={setSelectedSortList}
            />
            <PublicCalendarLinkButtonV3 />
          </>
        )}
      </Box>
    </>
  );
};
